import { useGetRequest } from '../../hooks/utils/useGetRequest';
import { CardInformation } from '../../interfaces/card-information';

const useGetCardInformation = (cardId: string) => {
  const path = `v1/cards/${cardId}/information`;

  const [{ data, error, loading }, execute] = useGetRequest<CardInformation>({
    path,
  });

  return {
    cardInformation: data,
    execute,
    isLoading: loading,
    isError: error,
  };
};

export default useGetCardInformation;
